module.exports = __webpack_public_path__ + "img/coins-fill.52f0b480.svg";